module.exports = __webpack_public_path__ + "static/media/1POLICY14.04053abf.jpg";